import * as React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useField } from "formik";

import { i18ndb, rest } from '../services';
import { useState,useEffect } from 'react';
import { FormControl, InputLabel } from '@mui/material';

const buildOptions = (list) => {
	if (!list)
		return [];
	const items = [];
	for (const [key, value] of Object.entries(list)) {
		items.push(<MenuItem key={key} value={key}>{i18ndb._(value)}</MenuItem>);
	}
	return items;
}

/**
	Props:
	entity: entity containing the metadata in the backend
	metadata: content of the metadata if not taken from the backend
 */
export function Select(props) {
	const [option,setOption] = useState({'':'loading...'})
	const [field, meta, helpers] = useField(props.name);
	const { value } = meta;
	const { setValue } = helpers;

	useEffect(()=>{
		if (props.entity) {
			rest.list(props.entity, {})
				.then(response => {
					setOption(response)
				});
			} else {
				setOption(props.list)

			}
	},[props.entity])
	
	let options = buildOptions(option);

	const handleChange = event => {
		setValue(event.target.value);
	};
  
	return (
		<div>
		<FormControl variant="standard">
			<InputLabel shrink htmlFor={props.name}>
				{props.label}
			</InputLabel>
			<TextField
				select
				value={value}
				onChange={handleChange}
				onBlur={props.onBlur}
				name={props.name}
				disabled={props.disabled}
				InputLabelProps={{shrink: false}}
				>
				{options}
			</TextField>
		  </FormControl>
		</div>
	);
  }
